import { isValidElement, cloneElement } from 'react';
import { svgUtil } from '@asphalt-react/helper';
import PropTypes from 'prop-types';

/**
 * Appends the dimensions of SVG according to size prop
 *
 * @param {object} param
 * @returns {object}
 */

const SvgNormalizer = ({
  size,
  children
}) => {
  if ( /*#__PURE__*/isValidElement(children) && typeof children.type === "function" && !children.props.mdxType) {
    if (svgUtil.isSVG(children.type())) return /*#__PURE__*/cloneElement(children.type(), size);
  }

  if ( /*#__PURE__*/isValidElement(children) && children.props.mdxType && typeof children.props.originalType === "function") {
    return /*#__PURE__*/cloneElement(children.props.originalType(), size);
  }

  if (svgUtil.isSVG(children)) {
    return /*#__PURE__*/cloneElement(children, size);
  }

  return children;
};
SvgNormalizer.propTypes = {
  /**
   * SVG or SVG wrapped React component.
   */
  children: PropTypes.node.isRequired,

  /**
   * Required dimensions of svg
   */
  size: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string
  }).isRequired
};

export { SvgNormalizer as default };
